<template>
	<div>
		<div>
			<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">预算汇总查询表</div>
			<el-row style="margin-top: 9px;">
				<div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">
					<el-row>
						<!-- 左侧组织架构 -->
						<el-col :span="4" style="background-color: #f7f8fa; height: 750px;">
							<Structure ref="Structure" @parentFind="Find" :condition="condition"></Structure>
						</el-col>

						<!-- 右侧列表 -->
						<el-col :span="20">
							<el-row style="padding-left: 2%; padding-top: 40px;">
								<el-col :span="5">
									<span style="margin-left: 10px;">年度</span>
									<el-date-picker v-model="condition.annual" type="year" format="yyyy"
										value-format="yyyy" style="margin-left:10px;width:180px">
									</el-date-picker>
								</el-col>

								<el-col :span="10">
									<span>体系名称 </span>
									<el-select v-model="condition.series_id" style="margin-left:10px;width:180px"
										:placeholder="postPlaceholder" clearable>
										<el-option v-for="item in seriesList" :key="item.id" :label="item.data" :value="item.id">
										</el-option>
									</el-select>
								</el-col>

								<!-- <el-col :span="5">
									<el-input v-model="condition.estimate_collection_amount" style="margin-left:10px;width:220px"
										placeholder="请输入查询内容">
									</el-input>
								</el-col> -->

								<el-col :span="2">
									<el-button
										style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
										@click="Find">
										查询</el-button>
								</el-col>
								<el-col :span="2">
									<el-button
										style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
										@click="Add">
										导出</el-button>
								</el-col>
							</el-row>

							<el-row style="margin: 0px 2%; margin-top: 20px;display: flex;">
								<div style="color: #006E4B;">
									<img src="../../../assets/budget/基本信息.png"
										style="vertical-align: middle;margin-top: -2px;" />
									<span style="font-weight: 600;">基本信息</span>
								</div>
								<div style="margin-left: 50px;">
									<span style="color:#a3a3a3 ;">年度:</span>
									<span style="font-weight: 600;">{{condition.annual}}</span>
								</div>
								<div style="margin-left: 50px;">
									<span style="color:#a3a3a3 ;">当前架构:</span>
									<span style="font-weight: 600;">{{condition.project_name}}</span>
								</div>
							</el-row>

							<el-row style="margin: 0px 2%; margin-top: 20px;">

								<el-row>
									<el-table :header-cell-style="{background:'#d3eae2',color:'#000000'}"
										:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData"
										height="560" tooltip-effect="dark" style="width: 100%;" border
										@selection-change="handleSelectionChange">
										<el-table-column align="center" label="序号" width="50">
											<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
										</el-table-column>
										<el-table-column prop="firstName" align="center" label="预算分类" width="120">
										</el-table-column>
										<el-table-column prop="secondaryName" align="center" label="预算名称" width="120">
										</el-table-column>
										<el-table-column prop="illustrate" align="center" label="说明" width="200">
										</el-table-column>
										<el-table-column prop="accumulate_1" align="center" label="1月累计">
										</el-table-column>
										<el-table-column prop="accumulate_2" align="center" label="2月累计">
										</el-table-column>
										<el-table-column prop="accumulate_3" align="center" label="3月累计">
										</el-table-column>
										<el-table-column prop="accumulate_4" align="center" label="4月累计">
										</el-table-column>
										<el-table-column prop="accumulate_5" align="center" label="5月累计">
										</el-table-column>
										<el-table-column prop="accumulate_6" align="center" label="6月累计">
										</el-table-column>
										<el-table-column prop="accumulate_7" align="center" label="7月累计">
										</el-table-column>
										<el-table-column prop="accumulate_8" align="center" label="8月累计">
										</el-table-column>
										<el-table-column prop="accumulate_9" align="center" label="9月累计">
										</el-table-column>
										<el-table-column prop="accumulate_10" align="center" label="10月累计">
										</el-table-column>
										<el-table-column prop="accumulate_11" align="center" label="11月累计">
										</el-table-column>
										<el-table-column prop="accumulate_12" align="center" label="12月累计">
										</el-table-column>
										<el-table-column prop="accumulate" align="center" label="总计"></el-table-column>
									</el-table>
								</el-row>
								<el-row style="margin-top: 10px; text-align: center;">
									<el-pagination background @current-change="handleCurrentChange"
										:page-size="page_size" layout=" prev, pager, next, jumper" :total="total">
									</el-pagination>
								</el-row>
							</el-row>

						</el-col>
					</el-row>

				</div>
			</el-row>
		</div>
	</div>
</template>

<script>
	import Structure from "../../utils/structure/structure.vue";

	import axios from "axios";
	export default {
		components: {
			Structure: Structure,
		},
		data() {
			return {
				//列表相关
				total: 0,
				tableData: [],
				seriesList:[],

				//页面相关
				showDialog: false,

				//条件
				condition: {
					page_num: 1,
					page_size: 10,
					project_id: '',
					project_name: '',
					annual: '',
					series_id:'',
				},

				//复选框ids
				ids: [],
			};
		},
		methods: {
			//查询
			async Find() {
				var record = {
					page_num: this.condition.page_num,
					page_size: this.condition.page_size,
					project_id: this.condition.project_id,
					annual: this.condition.annual,
					series_id: this.condition.series_id,
				}
				var data = await this.$globals.AxiosPost('formSummary/getList', record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			
			getNowTimeyear() {
				var date = new Date(),
					year = date.getFullYear();
				this.condition.annual = year.toString();
				console.log(this.condition.annual)
			},
			async getProjectList() {
				var res = await this.$globals.AxiosPost('AccountsInvoiceRegistration/getProjectList', {});
				this.ProjectList = res.data
			},

			async getSeriesList() {
				var seriesList = await this.$globals.AxiosPost("dictionaries/selectFind", {
			    data_grouping: "business_series"
			});
			this.seriesList = seriesList.data;
			},
			// async getSectorList() {
			// 	var seriesList = await this.$globals.AxiosPost("dictionaries/selectFind", {
			//     data_grouping: "business_series"
			// });
			// this.seriesList = seriesList.data;
			// },
			
			//分页
			handleCurrentChange(val) {
				this.condition.page_num = val
				this.Find();
			},

		},
		async created() {
			this.getSeriesList();
			this.getNowTimeyear();
			this.Find();
		}
	}
</script>

<style scoped="scoped">
	.el-button--goon:focus,
	.el-button--goon:hover {
		background: #006e4b;
		border-color: #05573d;
	}

	.el-button--addbtn:focus,
	.el-button--addbtn:hover {
		border-color: #05573d;
		color: #006e4b;
	}

	.el-button--goon {
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-button--addbtn {
		color: #006e4b;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #006e4b;
		border-color: #006e4b;
	}

	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #006e4b;
	}

	.el-checkbox__inner:hover {
		border-color: #006e4b;
	}

	.el-button--pic {
		color: #006E4B;
		background-color: #fff;
		border-color: #006E4B;
		font-size: 10px;
		height: 30px;
		width: 70px;
		padding: 10px;
	}

	.el-button--pic:focus,
	.el-button--pic:hover {
		background: #fff;
		border-color: #05573d;
		color: #006E4B;
	}

	>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006E4B;
	}

	>>>.el-input__inner:focus {
		border-color: #006E4B;
	}

	>>>.el-select .el-input.is-focus .el-input__inner {
		border-color: #006E4B;
	}

	>>>.el-checkbox__input.is-checked .el-checkbox__inner,
	>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #006E4B;
		border-color: #006E4B;
	}

	>>>.el-checkbox__inner:hover {
		border-color: #006E4B;
	}

	>>>.el-tree-node.is-expanded>.el-tree-node__children {
		display: inline;
	}
</style>



// WEBPACK FOOTER //
// Summary.vue?3897d163